<template>
    <b-modal
        ref="modalDeleteDevice"
        title="Delete Device"
        title-tag="h2"
        :lazy="true"
        footer-class="d-flex"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :busy="isDeleting"
        @hide="reset"
    >
        <p>
            If this device is deleted, it will no longer be available to use for
            <br />
            processing credit card payments. Are you sure you want to delete
            this device?
        </p>

        <template #modal-footer>
            <b-button
                class="mr-auto"
                variant="secondary"
                @click="$refs.modalDeleteDevice.hide()"
                :disabled="isDeleting"
            >
                Cancel
            </b-button>

            <loader v-if="isDeleting" :margin="1" />
            <b-button v-else variant="primary" @click="deleteDevice">
                Delete
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";
import DevicesListService from "@/services/setting/devices-list";

export default {
    components: {
        Loader
    },
    data() {
        return {
            isDeleting: false,
            deviceToDelete: null
        };
    },
    methods: {
        open(device) {
            if (!device || !device.id) {
                this._message("Invalid device.", "danger");
                return;
            }
            this.deviceToDelete = device;
            this.$refs.modalDeleteDevice.show();
        },
        reset() {
            this.deviceToDelete = null;
        },
        async deleteDevice() {
            this.isDeleting = true;

            try {
                const response = await DevicesListService.deleteSettingsDevice({
                    id: this.deviceToDelete.id
                });

                const resData = response?.data?.response?.message;

                if (resData && resData.code === 200) {
                    this._message(resData.description, "success");
                    this.$emit("device-deleted", this.deviceToDelete.id);
                    this.$refs.modalDeleteDevice.hide();
                } else {
                    this._message("Failed to delete device.", "danger");
                }
            } catch (error) {
                this._message("Failed to delete device.", "danger");
            } finally {
                this.isDeleting = false;
            }
        }
    }
};
</script>
